import Block, { BlockContent, BlockGrid } from "~/components/Block";
import InstagramReel from "~/components/InstagramReel";
import { getCommonSliceProps } from "~/external/prismic";
import connectSlice from "~/lib/connectSlice";

type CardType = {
  instagram_reel_id?: string;
};

function VerticalVideoSlice(props) {
  const {
    spacingTop = 0,
    spacingBottom = 6,

    backgroundColor,
    color,

    cards = [],
    columnsOnDesktop = 3,
    columnsOnMobile = 1,
  } = props;

  return (
    <Block
      spacingTop={spacingTop}
      spacingBottom={spacingBottom}
      backgroundColor={backgroundColor}
      color={color}
    >
      <BlockContent>
        <BlockGrid columnsOnMobile={columnsOnMobile} cols={columnsOnDesktop}>
          {cards.map((card: CardType, i) => (
            <InstagramReel instagram_reel_id={card.instagram_reel_id} />
          ))}
        </BlockGrid>
      </BlockContent>
    </Block>
  );
}

export function mapSliceToProps(slice) {
  const { primary, items = [] } = slice;

  const props = {
    ...getCommonSliceProps(slice),

    columnsOnDesktop: primary.columns_on_desktop || 3,
    columnsOnMobile: primary.columns_on_mobile || 1,

    cards: items.map((item) => {
      return {
        instagram_reel_id: item.instagram_reel_id,
      };
    }),
  };

  return props;
}

export default connectSlice(mapSliceToProps)(VerticalVideoSlice);
